import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  perspective: 1000px;
  z-index: 500;
  background: #000000b0;
`;

export default Container;
